import { HStack, Image, Text, VStack } from '@chakra-ui/react';
import { Avatar } from '@ui/components/avatar';
import { Num } from '@ui/components/Num';
import SkeletonOrText from '@ui/components/SkeletonOrText';
import { DEX_NAME } from '@ui/config/layer';
import { useAgent } from '@ui/hooks/api/useAgent';
import { useTokenBalance } from '@ui/hooks/contracts/useTokenBalance';
import { useBondingTokenOrAgentTokenPrice } from '@ui/hooks/tokenPrice';
import { useGlobalChainLayer } from '@ui/hooks/useGlobalChainLayer';
import type { FC } from 'react';

import { UsdValue } from '../../Num/UsdValue';
import { useGraduateModal } from '../useGraduateModal';

export const DefaultContent: FC = () => {
  const chainLayer = useGlobalChainLayer();
  const tokenAddress = useGraduateModal((s) => s.address);
  const { data: balance } = useTokenBalance({ tokenAddress });
  const { data: price } = useBondingTokenOrAgentTokenPrice({
    bondingAddress: tokenAddress,
  });
  const agentInfo = useAgent({ tokenAddress }).data;

  return (
    <VStack gap={0} px={5} pt={6} pb="100px" align="stretch">
      <Avatar
        mx="auto"
        rounded="full"
        src={agentInfo?.image_url}
        boxSize="68px"
      />
      <Text mt={4} textStyle="body2" textAlign="center">
        Agent <SkeletonOrText>{agentInfo?.name}</SkeletonOrText> (
        <SkeletonOrText>{agentInfo?.symbol}</SkeletonOrText>) is now available
        for trading on {DEX_NAME[chainLayer]} \(o v o)/
        <br />
        <br />
        To trade your ${agentInfo?.symbol} tokens you need to unwrap your tokens
        from the bonding curve first.
      </Text>
      <HStack mt={6} justify="space-between" align="top">
        <Text textStyle="body2">You are holding</Text>
        <VStack gap={1} align="flex-end">
          <HStack fontWeight="bold">
            <Num value={balance} textStyle="body2Bold" />
            <Image
              rounded="full"
              alt="Agent"
              src={agentInfo?.image_url}
              boxSize="16px"
            />
          </HStack>
          <HStack textStyle="body3">
            <UsdValue
              value={balance}
              price={price?.usd_price}
              prefix="~$"
              decimalPlaces={2}
            />
          </HStack>
        </VStack>
      </HStack>
    </VStack>
  );
};
